import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import { selectActualDefaultLanguage, selectIsStaticSalesDemo } from 'containers/App/selectors'
import { fetchParticipantsData } from 'containers/AwarenessCenter/Campaigns/AutonomousScheduler/actions'
import { saveEndUserAlerts as handleGroupSettingsSave } from 'containers/GroupSettings/Wizard/actions'
import { selectEndUserAlerts } from 'containers/GroupSettings/Wizard/selectors'
import { selectCompanyFilter } from 'containers/PartnerOptions/selectors'
import { addToast } from 'containers/Toasts/actions'

import AnnouncementEditor from 'components/pages/settings/notifications/enduser/AnnouncementEditor'

import actions from './actions'
import {
  selectError,
  selectHasChangedRecipientsField,
  selectLoader,
  selectRecipients,
  selectRecipientsSearchFilter,
  selectRecipientsSelectorData,
} from './selectors'

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...actions,
      addToast,
      handleGroupSettingsSave,
      fetchParticipantsData,
    },
    dispatch
  )
const mapStateToProps = (state) => ({
  loader: selectLoader(state),
  error: selectError(state),
  groupSettingsAlerts: selectEndUserAlerts(state),
  defaultLanguage: selectActualDefaultLanguage(state),
  companyFilter: selectCompanyFilter(state),
  isStaticSalesDemo: selectIsStaticSalesDemo(state),
  recipientsSelectorData: selectRecipientsSelectorData(state),
  recipients: selectRecipients(state),
  recipientsSearchFilter: selectRecipientsSearchFilter(state),
  hasChangedRecipientsField: selectHasChangedRecipientsField(state),
})

const render = connect(mapStateToProps, mapDispatchToProps)(AnnouncementEditor)

export default withRouter(render)
